import React from "react";
import { Provider } from "react-redux";
import Routes from "./Routes";

interface IProps {
  store: any;
  history: any;
}

const Root = ({ store }: IProps) => (
  <Provider store={store}>
    <Routes />
  </Provider>
);

export default Root;
